<div class="send-contact-header">
    <div class="contact-title">Send Contact Card</div>
    <div class="close-btn" (click)="closeSendContact()">x</div>
</div>
<div class="send-contact-body mat-mdc-expansion-panel-content">
    <ng-container [formGroup]="contactInfo">
        <div class="control-div">
            <div class="control-label-container">
                <label class="control-label"> First Name </label>
            </div>
            <input class="control-input" activeForm [activeForm]="contactInfo" id="firstname"
                   [formControlName]="'firstName'"
                   placeholder="Enter your first name" style="resize: none"/>
        </div>
        <div class="control-div">
            <div class="control-label-container">
                <label class="control-label"> Last Name </label>
            </div>
            <input class="control-input" activeForm [activeForm]="contactInfo" id="lastname"
                   [formControlName]="'lastName'"
                   placeholder="Enter your first name" style="resize: none"/>
        </div>
        <div class="control-div">
            <div class="control-label-container">
                <label class="control-label"> Formatted Name </label>
            </div>
            <input class="control-input" activeForm [activeForm]="contactInfo" id="formattedname"
                   [formControlName]="'formattedName'"
                   placeholder="Enter your formatted name" style="resize: none"/>
        </div>

        <contacts-template [contactInfo]="contactInfo" (delete)="deleteTemplate($event)"></contacts-template>
    </ng-container>

    <contact-dropdown-button (addContact)="addContact($event)" [contactInfo]="contactInfoRawData"></contact-dropdown-button>
</div>

<div class="send-contact-footer" (click)="sendContact()">
    <div class="send-contact-btn">Send Contact</div>
</div>